import style from "./Taxi.module.scss";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
// Mui
import LinearProgress from "@mui/material/LinearProgress";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardActions from "@mui/material/CardActions";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Chip from "@mui/material/Chip";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import TextField from "@mui/material/TextField";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Pagination from "@mui/material/Pagination";
import PhotoLibraryIcon from "@mui/icons-material/PhotoLibrary";
import Tooltip from "@mui/material/Tooltip";
import UTurnLeftIcon from "@mui/icons-material/UTurnLeft";
import StarHalfIcon from "@mui/icons-material/StarHalf";
import StarIcon from "@mui/icons-material/Star";
import AddPhotoAlternateIcon from "@mui/icons-material/AddPhotoAlternate";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
// API
import useGetAllTaxiOrdersApi from "../../../API/useGetAllTaxiOrdersApi";
import useUpdateTaxiOrderApi from "../../../API/useUpdateTaxiOrderApi";
import useAddImageTaxiOrderApi from "../../../API/useAddImageTaxiOrderApi";

const cairoFontStyle = `
  @import url('https://fonts.googleapis.com/css2?family=Cairo:wght@400;500;600;700;800&display=swap');
  * { font-family: 'Cairo', sans-serif !important; }
`;

export default function Taxi() {
  const [toast, setToast] = useState({ open: false, message: "" });

  const closeToast = () => {
    setToast({ open: false, message: "" });
  };
  //
  const addImageMutation = useAddImageTaxiOrderApi();

  // Attach ticket modal state
  const [imageModalOpen, setImageModalOpen] = useState(false);
  const [imageUploadRow, setImageUploadRow] = useState(null);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [imageUploadError, setImageUploadError] = useState(null);

  const openImageModal = (row) => {
    setImageUploadError(null);
    setSelectedFiles([]);
    setImageUploadRow(row);
    setImageModalOpen(true);
  };

  const closeImageModal = () => {
    setImageModalOpen(false);
    setImageUploadRow(null);
    setSelectedFiles([]);
    setImageUploadError(null);
  };

  const handleFileSelect = (e) => {
    const files = Array.from(e.target.files || []);
    setSelectedFiles(files);
  };

  const handleUploadImages = async () => {
    if (!selectedFiles.length) {
      setImageUploadError("يرجى اختيار صورة واحدة على الأقل");
      return;
    }
    setImageUploadError(null);
    try {
      const result = await addImageMutation.mutateAsync({
        id: imageUploadRow.id,
        images: selectedFiles,
      });

      const updatedImages = result?.data?.all_images || imageUploadRow.images;

      setRows((prevRows) => prevRows.map((row) => (row.id === imageUploadRow.id ? { ...row, images: updatedImages } : row)));

      // Close both modals
      closeImageModal();
      closeEditModal();

      // Show success toast
      setToast({ open: true, message: "تم رفع التذكرة بنجاح" });
    } catch (error) {
      const message = error?.response?.data?.message || "فشل في رفع الصور";
      setImageUploadError(message);
    }
  };

  // Add this state near the other modal states
  const [editError, setEditError] = useState(null);
  //
  const navigate = useNavigate();
  // MUI pagination
  const [page, setPage] = useState(1);
  const rowsPerPage = 10;
  //
  useEffect(() => {
    window.scrollTo(0, 0);
    const styleEl = document.createElement("style");
    styleEl.innerHTML = cairoFontStyle;
    document.head.appendChild(styleEl);
    return () => document.head.removeChild(styleEl);
  }, []);

  const { data, isPending: isGetAllOrdersPending, fetchStatus } = useGetAllTaxiOrdersApi();
  const updateMutation = useUpdateTaxiOrderApi();

  const formatPhoneForWhatsApp = (phone) => {
    if (!phone) return null;
    const cleaned = phone.replace(/\D/g, "");
    let formatted = cleaned;
    if (formatted.startsWith("0")) formatted = formatted.substring(1);
    if (formatted.length === 9) formatted = "966" + formatted;
    return formatted;
  };

  const formatDate = (dateString) => {
    if (!dateString) return "—";
    const date = new Date(dateString);
    return date.toLocaleDateString("en-GB", { day: "2-digit", month: "2-digit", year: "numeric" });
  };

  const formatHour = (timeStr) => {
    if (!timeStr) return "—";
    if (!timeStr.includes(":")) return timeStr;
    const [hours, minutes] = timeStr.split(":").map(Number);
    const period = hours >= 12 ? "م" : "ص";
    const hours12 = hours % 12 || 12;
    return `${hours12}:${minutes.toString().padStart(2, "0")} ${period}`;
  };

  const [rows, setRows] = useState([]);
  // page pagination
  const paginatedRows = rows.slice((page - 1) * rowsPerPage, page * rowsPerPage);
  useEffect(() => {
    setPage(1);
  }, [rows.length]);

  const handlePageChange = (event, value) => {
    setPage(value);

    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  //
  useEffect(() => {
    if (data?.data) {
      const formatted = data.data.map((item, index, array) => ({
        id: item.id,
        index: array.length - index,
        order_number: item.order_number,
        type: item.type,
        extra_route_access: item.extra_route_access,
        car_model: item.car_model,
        seats_number: item.seats_number,
        price: item.price,
        name: item.name,
        phone: item.phone,
        whatsapp_number: formatPhoneForWhatsApp(item.phone),
        pickup_location: item.pickup_location,
        neighborhood: item.neighborhood,
        pickup_date: item.pickup_date,
        status: item.status,
        new_status: item.new_status,
        date: item.created_at,
        pickup_hour: item.pickup_hour,
        hotel_name: item.hotel_name,
        driver_name: item.driver_name,
        driver_phone_number: item.driver_phone_number,
        driver_amount: item.driver_amount,
        images: item.images || [],

        parent_order_id: item.parent_order_id,
        has_return_trip: item.has_return_trip,
        is_return_trip: item.is_return_trip,

        // WhatsApp message sent flags
        wp_minus_sent: item.wp_minus_sent,
        wp_confirmed_unpaid_sent: item.wp_confirmed_unpaid_sent,
        wp_confirmed_paid_sent: item.wp_confirmed_paid_sent,
        wp_first_reminder_sent: item.wp_first_reminder_sent,
        wp_second_reminder_sent: item.wp_second_reminder_sent,
        wp_completed_sent: item.wp_completed_sent,
        wp_survey_sent: item.wp_survey_sent,
      }));
      setRows(formatted);
    }
  }, [data]);

  // Ticket image
  const openTicketImage = (images) => {
    if (!images || images.length === 0) return;

    const imageUrl = images[0].full_path;
    window.open(imageUrl, "_blank", "noopener,noreferrer");
  };

  // Modal state
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [editingRow, setEditingRow] = useState(null);
  const [editForm, setEditForm] = useState({});

  const openEditModal = (row) => {
    setEditError(null); // clear previous error
    setEditingRow(row);

    // Fix: parse as local date, not UTC
    const toLocalDateString = (dateStr) => {
      if (!dateStr) return "";
      const date = new Date(dateStr);
      const offset = date.getTimezoneOffset() * 60000;
      return new Date(date.getTime() - offset).toISOString().slice(0, 10);
    };

    setEditForm({
      name: row.name || "",
      phone: row.phone || "",
      type: row.type || "",
      pickup_location: row.pickup_location || "",
      neighborhood: row.neighborhood || "",
      hotel_name: row.hotel_name || "",
      car_model: row.car_model || "",
      seats_number: row.seats_number || "",
      pickup_date: toLocalDateString(row.pickup_date), // ← use helper
      pickup_hour: row.pickup_hour || "",
      price: row.price || "",
      status: row.status || "",
      new_status: row.new_status || "",

      driver_name: row.driver_name || "",
      driver_phone_number: row.driver_phone_number || "",
      driver_amount: row.driver_amount || "",
    });
    setEditModalOpen(true);
  };

  const closeEditModal = () => {
    setEditModalOpen(false);
    setEditingRow(null);
  };

  const handleFormChange = (field, value) => {
    setEditForm((prev) => ({ ...prev, [field]: value }));
  };

  // Replace handleSaveEdit with:
  const handleSaveEdit = async () => {
    setEditError(null);
    try {
      await updateMutation.mutateAsync({ id: editingRow.id, ...editForm });

      setRows((prevRows) =>
        prevRows.map((row) =>
          row.id === editingRow.id
            ? {
                ...row,
                ...editForm,
                whatsapp_number: formatPhoneForWhatsApp(editForm.phone),
              }
            : row
        )
      );

      closeEditModal();
    } catch (error) {
      const message = error?.response?.data?.message || "فشل في تحديث الطلب";
      setEditError(message);
    }
  };

  const inputSx = {
    "& .MuiInputBase-root": { fontFamily: "Cairo, sans-serif", borderRadius: "10px" },
    "& .MuiInputLabel-root": { fontFamily: "Cairo, sans-serif" },
  };

  const statusMap = {
    ناقص: { label: "ناقص", color: "warning" },
    "مؤكد غير مدفوع": { label: "مؤكد غير مدفوع", color: "info" },
    "مؤكد مدفوع": { label: "مؤكد مدفوع", color: "success" },
    "تذكير أول": { label: "تذكير أول", color: "success" },
    "تذكير ثاني": { label: "تذكير ثاني", color: "success" },
    استبيان: { label: "استبيان", color: "success" },
    مكتمل: { label: "مكتمل", color: "success" },
    ملغي: { label: "ملغي", color: "error" },
  };

  const wpMessageChips = [
    { label: "ناقص", field: "wp_minus_sent" },
    { label: "مؤكد غير مدفوع", field: "wp_confirmed_unpaid_sent" },
    { label: "مؤكد مدفوع", field: "wp_confirmed_paid_sent" },
    { label: "تذكير أول", field: "wp_first_reminder_sent" },
    { label: "تذكير ثاني", field: "wp_second_reminder_sent" },
    { label: "استبيان", field: "wp_survey_sent" },
    { label: "تحصيل", field: "wp_completed_sent" },
  ];

  return (
    <div className={style.container} dir="rtl">
      {(isGetAllOrdersPending || fetchStatus === "fetching" || updateMutation.isPending) && (
        <div className={style.progressContainer}>
          <LinearProgress />
        </div>
      )}

      <Grid container spacing={2} sx={{ p: 2 }}>
        {paginatedRows.map((row) => {
          const whatsappUrl = row.whatsapp_number ? `https://wa.me/${row.whatsapp_number}` : null;

          return (
            <Grid item xs={12} sm={6} md={4} lg={3} key={row.id}>
              <Card
                sx={{
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  borderRadius: "20px",
                  border: "1.5px solid #ebebeb",
                  backgroundColor: "#fff",
                  boxShadow: "0 2px 12px rgba(0,0,0,0.06)",
                  transition: "box-shadow 0.2s, transform 0.2s",
                  "&:hover": {
                    boxShadow: "0 8px 28px rgba(0,0,0,0.13)",
                    transform: "translateY(-2px)",
                  },
                  fontFamily: "Cairo, sans-serif",
                }}
              >
                <CardContent sx={{ flexGrow: 1, p: 2.5 }}>
                  {/* Header: Order # + Status chip */}
                  <Box display="flex" justifyContent="space-between" alignItems="center" mb={1.5}>
                    <Typography
                      sx={{
                        fontFamily: '"Cairo", sans-serif',
                        fontWeight: 800,
                        fontSize: "0.8rem",
                        color: "#888",
                        bgcolor: "#f5f5f5",
                        px: 1,
                        py: 0.3,
                        borderRadius: 1,
                      }}
                    >
                      {row.order_number}
                    </Typography>
                    <Chip
                      label={statusMap[row.new_status]?.label ?? row.new_status}
                      color={statusMap[row.new_status]?.color ?? "default"}
                      size="small"
                      sx={{
                        fontFamily: "Cairo, sans-serif",
                        fontWeight: "700",
                        fontSize: "11px",
                        borderRadius: "8px",
                        height: "24px",
                      }}
                    />
                  </Box>

                  <Box display="flex" justifyContent="space-between" alignItems="center" mb={0.5}>
                    {/* Name */}
                    <Typography
                      sx={{
                        fontFamily: "Cairo, sans-serif",
                        fontWeight: "800",
                        fontSize: "16px",
                        color: "#1a1a1a",
                      }}
                    >
                      {row.name || "—"}
                    </Typography>

                    <div style={{ display: "flex", gap: "6px" }}>
                      {row.has_return_trip && (
                        <Tooltip title="طلب ذهاب وعودة تم اضافة (جدولة) رحلة العودة الخاصة به">
                          <StarIcon sx={{ color: "#1a1a1a", cursor: "pointer" }} />
                        </Tooltip>
                      )}
                      {!row.has_return_trip && !row.is_return_trip && row.type === "ذهاب وعودة من جدة الى مكة" && (
                        <Tooltip title="طلب ذهاب وعودة لم يتم اضافة (جدولة) رحلة العودة الخاصة به">
                          <StarHalfIcon sx={{ color: "#1a1a1a", cursor: "pointer" }} />
                        </Tooltip>
                      )}
                      {row.is_return_trip && (
                        <Tooltip title="رحلة عودة">
                          <UTurnLeftIcon sx={{ color: "#1a1a1a", cursor: "pointer" }} />
                        </Tooltip>
                      )}

                      {row.images && row.images.length > 0 && (
                        <Tooltip title="تذكرة الطيران">
                          <PhotoLibraryIcon
                            sx={{ color: "#1a1a1a", cursor: "pointer" }}
                            onClick={(e) => {
                              e.stopPropagation();
                              openTicketImage(row.images);
                            }}
                          />
                        </Tooltip>
                      )}
                    </div>
                  </Box>

                  {/* Phone */}
                  {row.phone && (
                    <Box mb={1.5} dir="ltr" sx={{ textAlign: "right" }}>
                      {whatsappUrl ? (
                        <a
                          href={whatsappUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{
                            color: "#25D366",
                            textDecoration: "none",
                            fontWeight: "700",
                            fontSize: "14px",
                            fontFamily: "Cairo, sans-serif",
                            backgroundColor: "rgba(37, 211, 102, 0.1)",
                            padding: "3px 10px",
                            borderRadius: "8px",
                            display: "inline-block",
                          }}
                          onClick={(e) => e.stopPropagation()}
                        >
                          {row.phone}
                        </a>
                      ) : (
                        <Typography sx={{ fontFamily: "Cairo, sans-serif", fontSize: "14px" }}>{row.phone}</Typography>
                      )}
                    </Box>
                  )}

                  {/* All info rows — uniform pill style, no dividers */}
                  <Box sx={{ display: "flex", flexDirection: "column", gap: "6px" }}>
                    <InfoRow label="الخدمة" value={row.type} />
                    {row.extra_route_access && <InfoRow label="خدمة إضافية" value="المسار" />}
                    <InfoRow label="مكان الاستقبال" value={row.pickup_location} />
                    {row.neighborhood && row.neighborhood !== "N/A" && <InfoRow label="الحي" value={row.neighborhood} />}
                    <InfoRow label="السيارة" value={row.car_model} />
                    <InfoRow label="فندق" value={row.hotel_name} />
                    <InfoRow label="تاريخ الاستقبال" value={formatDate(row.pickup_date)} />
                    <InfoRow label="ساعة الوصول" value={formatHour(row.pickup_hour)} />
                    {/* <InfoRow label="تاريخ الطلب" value={formatDate(row.date)} /> */}
                    <InfoRow label="الإجمالي" value={row.price} highlight />
                  </Box>
                </CardContent>

                {/* Actions */}
                <CardActions sx={{ px: 2.5, pb: 2.5, pt: 0.5 }}>
                  <Button
                    variant="contained"
                    fullWidth
                    onClick={() => openEditModal(row)}
                    sx={{
                      backgroundColor: "#1976d2",
                      fontFamily: "Cairo, sans-serif",
                      fontWeight: "700",
                      fontSize: "15px",
                      borderRadius: "12px",
                      py: 1,
                      boxShadow: "none",
                      "&:hover": {
                        backgroundColor: "#1565c0",
                        boxShadow: "0 4px 12px rgba(25,118,210,0.35)",
                      },
                    }}
                  >
                    تعديل
                  </Button>
                </CardActions>
              </Card>
            </Grid>
          );
        })}
      </Grid>

      <Box display="flex" justifyContent="center" alignItems="center" mt={3} mb={4}>
        <Pagination count={Math.ceil(rows.length / rowsPerPage)} page={page} onChange={handlePageChange} color="primary" shape="rounded" hidePrevButton hideNextButton />{" "}
      </Box>

      {/* Edit Modal */}
      <Modal open={editModalOpen} onClose={closeEditModal}>
        <Box
          dir="rtl"
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: { xs: "92vw", sm: 520 },
            maxHeight: "90vh",
            overflowY: "auto",
            backgroundColor: "#fff",
            borderRadius: "20px",
            boxShadow: "0 20px 60px rgba(0,0,0,0.2)",
            p: 3,
            fontFamily: "Cairo, sans-serif",
          }}
        >
          {/* Modal Header */}
          <Box display="flex" justifyContent="space-between" alignItems="center" mb={2.5}>
            <Typography
              sx={{
                fontFamily: "Cairo, sans-serif",
                fontWeight: "800",
                fontSize: "20px",
                color: "#1a1a1a",
              }}
            >
              تعديل الطلب: {editingRow?.order_number}
            </Typography>
            <IconButton onClick={closeEditModal} size="small" sx={{ color: "#888" }}>
              <CloseIcon />
            </IconButton>
          </Box>

          {/* WhatsApp messages sent status */}
          <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.8, mb: 2.5 }}>
            {wpMessageChips.map(({ label, field }) => {
              const sent = Boolean(editingRow?.[field]);
              return (
                <Chip
                  key={field}
                  label={label}
                  size="small"
                  variant={sent ? "filled" : "outlined"}
                  color={sent ? "success" : "default"}
                  sx={{
                    fontFamily: "Cairo, sans-serif",
                    fontWeight: 700,
                    fontSize: "12px",
                    borderRadius: "8px",
                  }}
                />
              );
            })}
          </Box>

          {/* Form Fields */}
          <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
            {[
              { field: "name", label: "الاسم", dir: "rtl" },
              { field: "phone", label: "رقم الهاتف", dir: "ltr" },
              { field: "type", label: "الخدمة", dir: "rtl" },
              { field: "pickup_location", label: "مكان الاستقبال", dir: "rtl" },
              { field: "neighborhood", label: "الحي", dir: "rtl" },
              { field: "car_model", label: "السيارة", dir: "rtl" },
              { field: "hotel_name", label: "فندق", dir: "rtl" },
              { field: "pickup_date", label: "تاريخ الاستقبال", type: "date", dir: "ltr" },
              { field: "pickup_hour", label: "ساعة الوصول", type: "time", dir: "ltr" },
              // { field: "seats_number", label: "عدد المقاعد" },
              { field: "price", label: "الإجمالي", dir: "ltr" },

              // { field: "driver_name", label: "اسم السائق", dir: "rtl" },
              // { field: "driver_phone_number", label: "رقم السائق", dir: "ltr", placeholder: "05xxxxxxxx" },
              // { field: "driver_amount", label: "مبلغ السائق", dir: "ltr" },
            ].map(({ field, label, type, dir, placeholder }) => (
              <TextField
                key={field}
                label={label}
                value={editForm[field] || ""}
                onChange={(e) => handleFormChange(field, e.target.value)}
                type={type || "text"}
                size="small"
                fullWidth
                InputLabelProps={type === "date" || type === "time" ? { shrink: true } : {}}
                sx={inputSx}
                dir={dir}
                placeholder={placeholder || ""}
              />
            ))}

            {/* Status Select */}
            <FormControl size="small" fullWidth>
              <InputLabel sx={{ fontFamily: "Cairo, sans-serif" }}>الحالة</InputLabel>
              <Select
                value={editForm.new_status || ""}
                label="الحالة"
                onChange={(e) => handleFormChange("new_status", e.target.value)}
                sx={{
                  fontFamily: "Cairo, sans-serif",
                  borderRadius: "10px",
                  "& .MuiSelect-select": { fontFamily: "Cairo, sans-serif" },
                }}
              >
                {[
                  { value: "ناقص", label: "ناقص" },
                  { value: "مؤكد غير مدفوع", label: "مؤكد غير مدفوع" },
                  { value: "مؤكد مدفوع", label: "مؤكد مدفوع" },
                  { value: "تذكير أول", label: "تذكير أول" },
                  { value: "تذكير ثاني", label: "تذكير ثاني" },
                  { value: "استبيان", label: "استبيان" },
                  { value: "مكتمل", label: "مكتمل" },
                  { value: "ملغي", label: "ملغي" },
                ].map((s) => (
                  <MenuItem dir="rtl" key={s.value} value={s.value} sx={{ fontFamily: "Cairo, sans-serif" }}>
                    {s.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>

          {/* Error Message */}
          {editError && (
            <Box
              sx={{
                mt: 2.5,
                backgroundColor: "#fff3e0",
                border: "1px solid #ffb74d",
                borderRadius: "12px",
                px: 2,
                py: 1.2,
                display: "flex",
                alignItems: "flex-start",
                gap: 1,
              }}
            >
              <Typography sx={{ fontSize: "20px", lineHeight: 1.3 }}>⚠️</Typography>
              <Typography
                sx={{
                  fontFamily: "Cairo, sans-serif",
                  fontSize: "13px",
                  fontWeight: 600,
                  color: "#e65100",
                  lineHeight: 1.7,
                }}
              >
                {editError}
              </Typography>
            </Box>
          )}

          {/* Modal Actions */}
          {!editingRow?.is_return_trip && (
            <Box display="flex" gap={1.5} mt={3}>
              <Button
                fullWidth
                variant="contained"
                size="small"
                onClick={() => navigate(`/dashboard/taxi/add-return-trip/${editingRow?.id}`)}
                sx={{
                  fontFamily: "Cairo, sans-serif",
                  fontWeight: "700",
                  fontSize: "15px",
                  borderRadius: "12px",
                  py: 1,
                  boxShadow: "none",
                  bgcolor: "#2e7d32",
                  "&:hover": { bgcolor: "#1b5e20" },
                }}
              >
                إنشاء رحلة عودة
              </Button>
            </Box>
          )}

          {/* Attach ticket — only if no image yet AND not a return trip */}
          {(!editingRow?.images || editingRow.images.length === 0) && !editingRow?.is_return_trip && (
            <Box mt={2.5}>
              <Button
                variant="outlined"
                fullWidth
                // startIcon={<AddPhotoAlternateIcon />}
                onClick={() => openImageModal(editingRow)}
                sx={{
                  borderColor: "#1976d2",
                  color: "#1976d2",
                  fontFamily: "Cairo, sans-serif",
                  fontWeight: "700",
                  fontSize: "14px",
                  borderRadius: "12px",
                  py: 1,
                  "&:hover": { borderColor: "#1565c0", backgroundColor: "rgba(25,118,210,0.05)" },
                }}
              >
                إرفاق تذكرة طيران
              </Button>
            </Box>
          )}

          <Box display="flex" gap={1.5} mt={3}>
            <Button
              variant="contained"
              fullWidth
              onClick={handleSaveEdit}
              disabled={updateMutation.isPending}
              sx={{
                backgroundColor: "#1976d2",
                fontFamily: "Cairo, sans-serif",
                fontWeight: "700",
                fontSize: "15px",
                borderRadius: "12px",
                py: 1,
                boxShadow: "none",
                "&:hover": { backgroundColor: "#1565c0" },
              }}
            >
              {updateMutation.isPending ? "جاري الحفظ..." : "حفظ التعديلات"}
            </Button>
            <Button
              variant="outlined"
              fullWidth
              onClick={closeEditModal}
              sx={{
                borderColor: "#e0e0e0",
                color: "#555",
                fontFamily: "Cairo, sans-serif",
                fontWeight: "600",
                fontSize: "15px",
                borderRadius: "12px",
                py: 1,
              }}
            >
              إلغاء
            </Button>
          </Box>
        </Box>
      </Modal>

      {/* Attach Ticket Modal */}
      <Modal open={imageModalOpen} onClose={closeImageModal}>
        <Box
          dir="rtl"
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: { xs: "92vw", sm: 420 },
            backgroundColor: "#fff",
            borderRadius: "20px",
            boxShadow: "0 20px 60px rgba(0,0,0,0.2)",
            p: 3,
            fontFamily: "Cairo, sans-serif",
          }}
        >
          <Box display="flex" justifyContent="space-between" alignItems="center" mb={2.5}>
            <Typography sx={{ fontFamily: "Cairo, sans-serif", fontWeight: "800", fontSize: "18px", color: "#1a1a1a" }}>
              إرفاق تذكرة الطيران: {imageUploadRow?.order_number}
            </Typography>
            <IconButton onClick={closeImageModal} size="small" sx={{ color: "#888" }}>
              <CloseIcon />
            </IconButton>
          </Box>

          <Button
            component="label"
            variant="outlined"
            fullWidth
            // startIcon={<AddPhotoAlternateIcon />}
            sx={{
              fontFamily: "Cairo, sans-serif",
              fontWeight: "700",
              borderRadius: "12px",
              py: 1.2,
              borderStyle: "dashed",
            }}
          >
            اختر صورة
            <input type="file" hidden accept="image/*,.pdf" onChange={handleFileSelect} />
          </Button>

          {selectedFiles.length > 0 && (
            <Box sx={{ mt: 1.5, display: "flex", flexDirection: "column", gap: 0.5 }}>
              {selectedFiles.map((file, i) => (
                <Typography key={i} sx={{ fontFamily: "Cairo, sans-serif", fontSize: "13px", color: "#555" }}>
                  {file.name}
                </Typography>
              ))}
            </Box>
          )}

          {imageUploadError && (
            <Box
              sx={{
                mt: 2,
                backgroundColor: "#fff3e0",
                border: "1px solid #ffb74d",
                borderRadius: "12px",
                px: 2,
                py: 1.2,
                display: "flex",
                alignItems: "flex-start",
                gap: 1,
              }}
            >
              <Typography sx={{ fontSize: "18px", lineHeight: 1.3 }}>⚠️</Typography>
              <Typography sx={{ fontFamily: "Cairo, sans-serif", fontSize: "13px", fontWeight: 600, color: "#e65100" }}>{imageUploadError}</Typography>
            </Box>
          )}

          <Box display="flex" gap={1.5} mt={3}>
            <Button
              variant="contained"
              fullWidth
              onClick={handleUploadImages}
              disabled={addImageMutation.isPending}
              sx={{
                backgroundColor: "#1976d2",
                fontFamily: "Cairo, sans-serif",
                fontWeight: "700",
                fontSize: "15px",
                borderRadius: "12px",
                py: 1,
                boxShadow: "none",
                "&:hover": { backgroundColor: "#1565c0" },
              }}
            >
              {addImageMutation.isPending ? "جاري الرفع..." : "رفع"}
            </Button>
            <Button
              variant="outlined"
              fullWidth
              onClick={closeImageModal}
              sx={{
                borderColor: "#e0e0e0",
                color: "#555",
                fontFamily: "Cairo, sans-serif",
                fontWeight: "600",
                fontSize: "15px",
                borderRadius: "12px",
                py: 1,
              }}
            >
              إلغاء
            </Button>
          </Box>
        </Box>
      </Modal>

      <Snackbar open={toast.open} autoHideDuration={3000} onClose={closeToast} anchorOrigin={{ vertical: "bottom", horizontal: "center" }}>
        <Alert
          // onClose={closeToast}
          severity="success"
          variant="filled"
          icon={false}
          action={null}
          sx={{ fontFamily: "Cairo, sans-serif", fontWeight: "600", borderRadius: "12px" }}
        >
          {toast.message}
        </Alert>
      </Snackbar>
    </div>
  );
}

// Uniform info row — same pill background for every field
function InfoRow({ label, value, highlight }) {
  if (!value) return null;
  return (
    <Box
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      sx={{
        backgroundColor: "#f7f7f7",
        borderRadius: "10px",
        px: 1.5,
        py: 0.7,
      }}
    >
      <Typography
        sx={{
          fontFamily: "Cairo, sans-serif",
          fontSize: "12px",
          color: "#999",
          fontWeight: "500",
        }}
      >
        {label}
      </Typography>
      {highlight ? (
        <Box
          sx={{
            // backgroundColor: "#d33030",
            color: "#000000",
            // px: 1.2,
            // py: 0.2,
            borderRadius: "6px",
            fontWeight: "700",
            fontSize: "13px",
            fontFamily: "Cairo, sans-serif",
          }}
        >
          {value}
        </Box>
      ) : (
        <Typography
          sx={{
            fontFamily: "Cairo, sans-serif",
            fontSize: "13px",
            fontWeight: "600",
            color: "#1a1a1a",
          }}
        >
          {value}
        </Typography>
      )}
    </Box>
  );
}
